import styled from "styled-components";

export const PortfolioRow = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    flex-shrink: 0;
    padding-left: 6px;
    padding-right: 6px;
    border-bottom: 1px solid #d6d0c8;
`;